var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-item-header',{staticClass:"pc-note__notebook-details-header",attrs:{"name":"notebookDetails"}},[_vm._v("笔记本详情")])}
var staticRenderFns = []

export { render, staticRenderFns }